module.exports = __webpack_public_path__ + "static/img/aboutUs15.c9cb30b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/aboutUs15.jpg
// module id = 1367
// module chunks = 1